<template>
	<!-- 系统设置 -->
	<div class="aboutYjBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="back">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">系统设置</p>
				</div>
			</div>
		</van-sticky>
		<div class="xtszList">
			<div class="xtszListItem">
				<span>消息推送</span>
				<div>
					<van-switch v-model="checked" size="20px" active-color="#07c160" inactive-color="#ffffff" />
				</div>
			</div>
			<div class="xtszListItem">
				<span>同步</span>
				<div></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  data() {
	    return {
	      checked: true,
	    };
	  },
	  methods: {
	    onInput(checked) {
	      Dialog.confirm({
	        title: '提醒',
	        message: '是否切换开关？',
	      }).then(() => {
	        this.checked = checked;
	      });
	    },
		back() {
			this.$router.push('/set')
		}
	  },
	};
</script>

<style lang="less" scoped>
	.aboutYjBox{
		background-color: #fff;
		height: 100vh;
		overflow-y: scroll;
		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 80px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;
		
				.arrImg {
					img {
						width: 50px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}
		
				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}
		
		}
		//
		.xtszList{
			background-color: #fff;
			position: relative;
			.xtszListItem{
				margin: 0 16px;
				border-bottom: 1px solid #f0f0f0;/*no*/
				display: flex;
				line-height: 90px;
				
				span,div{
					flex:1;
					font-size: 30px;/*px*/
				}
				>div{
					text-align: right;
					position: relative;
					.van-switch{
						position: absolute;
						top: 50%;
						right: 0;
						transform: translateY(-50%);
						}
				}
			}
		}
	}

</style>
